import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["input", "hiddenInput", "preview"]
    static values = {fieldName: String, currentValue: String}

    connect() {
        this.initializeIconPicker()
    }

    initializeIconPicker() {
        // Initialize the FontIconPicker on the input field
        if (this.hasInputTarget && typeof $.fn.fontIconPicker === 'function') {
            $(this.inputTarget).fontIconPicker({
                theme: 'fip-bootstrap',
                emptyIcon: true,
                emptyIconValue: '',
                allCategoryText: 'All Icons',
                iconsPerPage: 30
            });

            // Listen for icon selection changes
            $(this.inputTarget).on('change', (e) => {
                this.updateHiddenField(e.target.value)
                this.updatePreview(e.target.value)
            })
        }
    }

    handleBundleSelection(event) {
        const bundleData = event.detail
        const iconValue = bundleData.icon || ''

        this.setIconValue(iconValue)
        this.enableField()
    }

    handleBundleCleared(event) {
        this.setIconValue('')
        this.disableField()
    }

    setIconValue(value) {
        // Update the FontIconPicker
        if (this.hasInputTarget && typeof $.fn.fontIconPicker === 'function') {
            $(this.inputTarget).fontIconPicker().setIcon(value)
        }
    }

    updateHiddenField(value) {
        if (this.hasHiddenInputTarget) {
            this.hiddenInputTarget.value = value
        }
    }

    updatePreview(value) {
        if (this.hasPreviewTarget) {
            const iconDisplay = this.previewTarget.querySelector('.selected-icon-display')
            if (value && value.trim() !== '') {
                iconDisplay.innerHTML = `<i class="${value}" style="font-size: 1.5em; margin-left: 0.5em;"></i>`
                this.previewTarget.style.display = 'block'
            } else {
                iconDisplay.innerHTML = ''
                this.previewTarget.style.display = 'none'
            }
        }
    }

    enableField() {
        if (this.hasInputTarget) {
            this.inputTarget.disabled = false
        }
    }

    disableField() {
        if (this.hasInputTarget) {
            this.inputTarget.disabled = true
        }
    }
}